import { render } from "./MySajuEditPage.vue?vue&type=template&id=8047381a&scoped=true"
import script from "./MySajuEditPage.vue?vue&type=script&lang=js"
export * from "./MySajuEditPage.vue?vue&type=script&lang=js"

import "./MySajuEditPage.vue?vue&type=style&index=0&id=8047381a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8047381a"]])

export default __exports__